// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tabla.css */
/* tabla.css */
.table-container header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;

    margin-right: 10%;
    /* Ajusta este valor según el espacio que desees */
}

.table-container .button-group {
    display: flex;
    gap: 0px;
    /* Ajusta el espacio entre botones si es necesario */
    margin-top: 10px;
    /* Ajusta el espacio entre el texto y los botones */
}

.table-container .button-group a {
    margin-bottom: 20px;
    /* Ajusta el espacio entre el texto y los botones */
}


.custom-button {
    margin-bottom: 10px;
    background-color: #007bff;
    /* Cambia el color del botón */
    color: white;
    border: none;
    padding: 23px 25px;
    /* Ajusta el padding para hacer el botón más alto */
    cursor: pointer;
    border-radius: 4px;
    margin-right: 12px;
    align-self: start;
}


.custom-button:hover {
    background-color: #0056b3;
    /* Color del botón al pasar el ratón por encima */
}

.table-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    background-size: cover;
    background-position: center;
    /* Ajusta la opacidad según lo necesites */
    z-index: -1;
}

.table-watermark {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 4rem;
    color: rgba(0, 0, 0, 0.1);
    /* Ajusta el color y la opacidad según lo necesites */
    z-index: -1;
}`, "",{"version":3,"sources":["webpack://./src/css/tabla.css"],"names":[],"mappings":"AAAA,cAAc;AACd,cAAc;AACd;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;;IAEnB,iBAAiB;IACjB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,oDAAoD;IACpD,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;IACnB,mDAAmD;AACvD;;;AAGA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mDAAmD;IACnD,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;;AAGA;IACI,yBAAyB;IACzB,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,2BAA2B;IAC3B,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,WAAW;AACf","sourcesContent":["/* Tabla.css */\n/* tabla.css */\n.table-container header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 20px;\n\n    margin-right: 10%;\n    /* Ajusta este valor según el espacio que desees */\n}\n\n.table-container .button-group {\n    display: flex;\n    gap: 0px;\n    /* Ajusta el espacio entre botones si es necesario */\n    margin-top: 10px;\n    /* Ajusta el espacio entre el texto y los botones */\n}\n\n.table-container .button-group a {\n    margin-bottom: 20px;\n    /* Ajusta el espacio entre el texto y los botones */\n}\n\n\n.custom-button {\n    margin-bottom: 10px;\n    background-color: #007bff;\n    /* Cambia el color del botón */\n    color: white;\n    border: none;\n    padding: 23px 25px;\n    /* Ajusta el padding para hacer el botón más alto */\n    cursor: pointer;\n    border-radius: 4px;\n    margin-right: 12px;\n    align-self: start;\n}\n\n\n.custom-button:hover {\n    background-color: #0056b3;\n    /* Color del botón al pasar el ratón por encima */\n}\n\n.table-background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #ffffff;\n    background-size: cover;\n    background-position: center;\n    /* Ajusta la opacidad según lo necesites */\n    z-index: -1;\n}\n\n.table-watermark {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 4rem;\n    color: rgba(0, 0, 0, 0.1);\n    /* Ajusta el color y la opacidad según lo necesites */\n    z-index: -1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
